import { Box } from '@mui/material'
import AudioVisualizerCanvas from "./AudioVisualizerCanvas"

const drawFilledMic = ( ctx, levels, width, height ) => {
    ctx.clearRect( 0, 0, width, height )

    // Define circular clipping path
    ctx.beginPath()
    ctx.arc( width / 2, height / 2, width / 2 - 1, 0, Math.PI * 2 )
    ctx.clip()

    // Fill based on level
    ctx.fillStyle = "white"
    const fillHeight = levels[0] * height
    ctx.fillRect( 0, height - fillHeight, width, fillHeight )
}


const AudioVisualizerMicFiller = ( { audioTrack, size = 30, scale = 1, frameColor = "#000", containerColor = "#333" } ) => {
    const scaleX = ( size / 24 ) * scale
    const scaleY = ( size / 24 ) * scale
    const micX = ( size - 24 * scaleX ) / 2 // center horizontally
    const micY = ( size - 24 * scaleY ) / 2 // center vertically
    return (
        <Box position="relative" bgcolor={containerColor} width={size} height={size} borderRadius="50%" overflow="hidden" >
            <svg
                style={{ position: "absolute", inset: 0, zIndex: 12 }}
                width={size}
                height={size}
                viewBox={`0 0 ${size} ${size}`}
                xmlns="http://www.w3.org/2000/svg"
            >
                <mask id="mic-cutout">
                    <rect width={size} height={size} fill="white" />
                    <path
                        d="M12,14c1.66,0,3-1.34,3-3V5c0-1.66-1.34-3-3-3S9,3.34,9,5v6C9,12.66,10.34,14,12,14z
                 M17,11c0,2.76-2.24,5-5,5s-5-2.24-5-5H5c0,3.53,2.61,6.43,6,6.92V21h2v-3.08
                 c3.39-0.49,6-3.39,6-6.92H17z"
                        fill="black"
                        transform={`translate(${micX}, ${micY}) scale(${scaleX}, ${scaleY})`}
                    />
                </mask>
                <rect
                    width={size}
                    height={size}
                    fill={frameColor}
                    mask="url(#mic-cutout)"
                />
            </svg>
            <AudioVisualizerCanvas
                audioTrack={audioTrack}
                type="filled-mic"
                draw={drawFilledMic}
                width={size}
                height={size}
            />
        </Box>
    )
}

export default AudioVisualizerMicFiller
